import * as yup from 'yup';

import isUUID from '~/utils/isUUID';

export const createOfferDeepLinkFormSchema = yup.object().shape({
  region: yup.string().required('Region is required'),
  offerId: yup.string().required('Offer ID is required'),
  approverId: yup
    .string()
    .required('Approver ID is required')
    .test('is-uuid', 'Approver ID must be a valid UUID', (value) => isUUID(value)),
  caseNumber: yup.string().required('Case Number is required'),
  notes: yup.string().optional(),
  openingReason: yup.string().required('Opening Reason is required'),
  openingReasonOther: yup.string().when('openingReason', {
    is: 'Other',
    then: (schema) => schema.required('Please specify the opening reason'),
    otherwise: (schema) => schema.optional(),
  }),
  salesAttribution: yup.string().required('Sales Attribution is required'),
});

export type CreateOfferDeepLinkFormValues = yup.InferType<typeof createOfferDeepLinkFormSchema>;
